// 2023/12/27 Leading Win 教育機能対応 DXWEBEDU00100_教育実施状況確認 start
import { RootState } from 'types';
export const educationStatusData = (state: RootState) => state.educationStatus;
// 2023/12/27 Leading Win 教育機能対応 DXWEBEDU00100_教育実施状況確認 end
